export const gatherings = {
  dek: {
    member:
      "There’s nothing better than a private community of people who are in it with you. Finally, your safe space. Join our upcoming events to find your people. Free for Premium members!",
    visitor:
      "Conceive’s community is a core part of what makes our program so successful. Our events create a safe space for our Premium members to gather and hear expert advice tailored just to them, which is why we believe they are three times more likely to become pregnant.",
  },
  haveAnIdea: {
    heading: "Have an idea for an event you don’t see here? Tell us!",
    subheading:
      "We'd love to hear your event ideas. Send them over in an email and we'll get back to you!",
    cta: "Email Us",
  },
  heading: "Events",
  meta: {
    description:
      "Conceive offers exclusive fertility- and pregnancy-focused digital events and support groups created for people looking for a safe space and supportive peers.",
    title: "Events",
  },
};
